"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GradientPanel = void 0;

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var GradientPanel = function GradientPanel(_ref) {
  var panelColor = _ref.panelColor,
      _ref$componentsArray = _ref.componentsArray,
      componentsArray = _ref$componentsArray === void 0 ? [] : _ref$componentsArray,
      panelType = _ref.panelType;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    panelColor: panelColor,
    className: panelType,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "main-container",
      children: componentsArray === null || componentsArray === void 0 ? void 0 : componentsArray.map(function (component) {
        return component;
      })
    })
  });
};

exports.GradientPanel = GradientPanel;